import React from 'react';

import AlertComponent from './AlertComponent';
import DashboardComponent from './Dashboard/DashboardComponent';
import ReviewsComponent from './Reviews/ReviewsComponent';
import HeartBeatComponent from './Heartbeat/HeartBeatComponent';
import KeywordsComponent from './Keywords/KeywordsComponent';
import FeedbackComponent from './Feedback/FeedbackComponent';
import ClientManagementComponent from './Client Management/ClientManagementComponent';
import ReportsComponent from './Reports/ReportsComponents';
import PredictorComponent from './Predictor AI/PredictorComponent';
import RoadmapGenerator from './Predictor AI/RoadmapGenerator';
import PersonaGenerator from './Predictor AI/PersonaGenerator';
import AppSettingsComponent from './Apps List/AppSettingsComponent';
import BenchmarkPage from '../pages/BenchmarksPage';
import RatingsPage from '../pages/RatingsPage';
import AppStateBackground from './App state Components/AppStateBackground';

function AppDataContainer({ component, app, subscription, handler }: any) {
    if (subscription?.status === 'expired' || subscription?.status === 'trial_expired') {
        return (
            <AppStateBackground
                isVisible={true}
                title={subscription?.status === 'expired' ? "Your subscription has expired." : "Your trial period has ended."}
                message={subscription?.status === 'expired' ? "Please renew your subscription to continue using the app." : "Please choose a plan to continue using the app."}
                onManageSubscription={() => { handler(); }}
            />
        );
    }
    if (component === 0) {
        return <DashboardComponent app={app} />
    } else if (component === 1) {
        return <ReviewsComponent subscription={subscription} app={app} />
    } else if (component === 2) {
        return <HeartBeatComponent subscription={subscription} app={app} />
    } else if (component === 3) {
        return <KeywordsComponent subscription={subscription} app={app} />
    } else if (component === 4) {
        return <PredictorComponent app={app} />
    } else if (component === 5) {
        return <RoadmapGenerator app={app} />
    } else if (component === 6) {
        return <PersonaGenerator app={app} />
    } else if (component === 7) {
        return <ReportsComponent app={app} subscription={subscription} handler={handler} />
    } else if (component === 8) {
        return <FeedbackComponent app={app} subscription={subscription} />
    } else if (component === 9) {
        return <AppSettingsComponent app={app} subscription={subscription} />
    } else if (component === 10) {
        return <ClientManagementComponent subscription={subscription} />
    } else if (component === 11) {
        return null;
    } else if (component === 12) {
        return <BenchmarkPage subscription={subscription} app={app} />
    } else if (component === 13) {
        return <RatingsPage subscription={subscription} app={app} />
    } else {
        return <AlertComponent alert={'Error loading component.'} />
    }
}

export default AppDataContainer;